import { render } from "./Suggestion.vue?vue&type=template&id=8be9130a&scoped=true&ts=true"
import script from "./Suggestion.ts?vue&type=script&lang=ts&external"
export * from "./Suggestion.ts?vue&type=script&lang=ts&external"

import "./Suggestion.scss?vue&type=style&index=0&id=8be9130a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be9130a"]])

export default __exports__